import { useOccContext } from '@vista-digital/occ-ui'

export const useHasCaptcha = (): boolean => {
    const occContext = useOccContext()
    return !!occContext.config.security.captcha?.siteKey.length
}
